function BtnArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.41376 0.999814C1.4138 0.734649 1.51915 0.480357 1.70665 0.292858C1.89415 0.105359 2.14845 4.97515e-06 2.41361 -3.50644e-05H10.8989C11.1641 4.97515e-06 11.4183 0.105359 11.6058 0.292858C11.7933 0.480357 11.8987 0.734649 11.8987 0.999814L11.8987 9.4851C11.8942 9.74726 11.7868 9.99715 11.5998 10.1809C11.4128 10.3647 11.1611 10.4677 10.8989 10.4677C10.6367 10.4677 10.385 10.3647 10.198 10.1809C10.0109 9.99715 9.9036 9.74726 9.89904 9.48509L9.89904 3.41388L1.7065 11.6064C1.51897 11.794 1.26461 11.8993 0.999395 11.8993C0.734179 11.8993 0.479825 11.794 0.292289 11.6064C0.104753 11.4189 -0.00060454 11.1645 -0.00060454 10.8993C-0.00060454 10.6341 0.104753 10.3797 0.292289 10.1922L8.48483 1.99966L2.41361 1.99966C2.14845 1.99962 1.89415 1.89427 1.70665 1.70677C1.51915 1.51927 1.4138 1.26498 1.41376 0.999814Z" fill="black" />
    </svg>
  );
}

function CustomButton() {
  return (
    <div className="btn-icon">
      <BtnArrow />
    </div>
  );
}

export default CustomButton;